import { Divider, Drawer, Space, Select, Button, Checkbox } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import BMInput from "../../comps/BMInput";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import Buttons from "../../UI/Buttons";
import { PaddingHorizontalIcon, PaddingVerticalIcon, AlignCenterIcon, AlignLeftIcon, AlignRightIcon } from "../../Icons";
import { previewLink, tt_name_block_warning } from "../../../utils/Utils";
import SliderInput from "../../UI/SiderInput";
import ButtonPicker from "../../../globals/styles/ButtonPicker";


export default function ButtonGrid(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [template, setTemplate] = useTemplate();
    const [content, setContent] = useState(props.content);
    const [w, setW] = useState(false);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        page = 0,
        location = "",
        component = "",
        name = "",
        can_delete = true,
        container = true,
        visibility = "visible",
        expiry_action = false,
        data = {},
        start_date = null,
        end_date = null,
        date_created = 0,
        date_changed = 0
    } = content;

    // Component specific
    const {
        padding_y = 10,
        padding_x = 10,
        width = 1248,
        constrain = false,
        align = "0 auto",
        gap_y = 10,
        gap_x = 10,
        justify = "space-evenly",
        background_colour = 0,
        preset = 0,
        button_block = false,
        buttons = [
            { label: "Button", link: "", tab: true },
            { label: "Button", link: "", tab: true },
            { label: "Button", link: "", tab: true },
        ],

    } = data;


    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const linkOut = (_image) => {


        if (_image?.link.includes("anchor:")) {
            let _f = props?.items.find(item => item.ee_id === _image.link.replace("anchor:", ""));
            if (_f) {
                let el = document.getElementById("bm-" + _f.id);
                let parent = document.getElementById("bm-scroll-area");
                let search = document.getElementById("search_bg");
                let search_bar_height = search.offsetHeight || 0;
                let nav = document.getElementById("bm_nav");
                let nav_height = nav.offsetHeight || 0;
                if (el && parent) {
                    parent.scrollTo({
                        top: el.offsetTop + search_bar_height + nav_height,
                        behavior: "smooth"
                    });
                }
            }
            return; 
        }

        if (_image.link) {
            window.open(previewLink(_image.link), (_image.tab) ? "_blank" : "_self");
        }
    }




    const drawButton = (_button, _index) => {
        return (
            <div style={{ "flex": (button_block) ? "1 1 auto" : "unset" }}>
                <Button block={button_block} className={"bm-btn-" + preset} onClick={() => linkOut(_button)}>{_button.label}</Button>
            </div>
        )
    }

    const drawRender = () => {

        const gridStyle = {
            display: 'flex',
            flexWrap: "wrap",
            justifyContent: justify,
            gap: `${gap_y}px ${gap_x}px`,
            padding: `${padding_y}px ${padding_x}px`,
            maxWidth: (constrain) ? width + "px" : "100%",
            border: (w) ? "4px solid deeppink" : "none",
            margin: align,
        };

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={{ background: getColor(background_colour, template) }}>
                    <div style={gridStyle}>
                        {buttons.map((item, index) => {
                            return drawButton(item, index);
                        })}
                    </div>
                </div>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />

                {/* BUTTON PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON TYPE</Divider>
                <ButtonPicker value={preset} onChange={(e) => setData({ ...data, "preset": e })} />
                <div className="shim" /> <div className="shim" />

                {/* BUTTONS */}
                <Buttons items={props.items} data={data} setData={setData} buttons={buttons} />
                <div className="shim" /> <div className="shim" />

                {/* GUTTER */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">GAP</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput value={gap_x} onChange={(_v) => setData({ ...data, "gap_x": _v })} number min={0} max={100} prefix="X" />
                        <BMInput value={gap_y} onChange={(_v) => setData({ ...data, "gap_y": _v })} number min={0} max={100} prefix="Y" />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />

                {/* MAX WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAX WIDTH</Divider>
                <div className="float-flex">

                    <SliderInput
                        onBeforeChange={() => setW(true)}
                        onAfterChange={() => setW(false)}
                        width={90}
                        min={0}
                        max={1248}
                        onChange={(_v) => setData({ ...data, "width": _v })}
                        disabled={!constrain}
                        value={width}
                    />

                    <Checkbox onChange={(e) => setData({ ...data, "constrain": e.target.checked })} checked={constrain}><small>Constrain?</small></Checkbox>
                </div>

                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN / PADDING</Divider>
                <div className="float-flex">

                    <Space>
                        <div><AlignLeftIcon onClick={() => setData({ ...data, "align": "0" })} style={{ "color": (align === "0") ? "#1890ff" : "#AAA" }} /></div>
                        <div><AlignCenterIcon onClick={() => setData({ ...data, "align": "0 auto" })} style={{ "color": (align === "0 auto") ? "#1890ff" : "#AAA" }} /></div>
                        <div><AlignRightIcon onClick={() => setData({ ...data, "align": "0 0 0 auto" })} style={{ "color": (align === "0 0 0 auto") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>

                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<PaddingHorizontalIcon style={{ "color": "#888" }} />} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<PaddingVerticalIcon style={{ "color": "#888" }} />} />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />


                {/* STACK */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">FORMAT</Divider>
                <Select value={button_block} onChange={(e) => setData({ ...data, "button_block": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
                    <Select.Option key={"center"} value={false}><small>Stack</small></Select.Option>
                    <Select.Option key={"start"} value={true}><small>Fill</small></Select.Option>

                </Select>
                <div className="shim" /> <div className="shim" />



                {/* GRID */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">GRID ALIGN</Divider>
                <Select value={justify} onChange={(e) => setData({ ...data, "justify": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
                    <Select.Option key={"center"} value={"center"}><small>Centre</small></Select.Option>
                    <Select.Option key={"start"} value={"start"}><small>Left</small></Select.Option>
                    <Select.Option key={"end"} value={"end"}><small>Right</small></Select.Option>
                    <Select.Option key={"space-between"} value={"space-between"}><small>Space Between</small></Select.Option>
                    <Select.Option key={"space-evenly"} value={"space-evenly"}><small>Space Evenly</small></Select.Option>
                    <Select.Option key={"space-around"} value={"space-around"}><small>Space Around</small></Select.Option>
                </Select>
                <div className="shim" /> <div className="shim" />

                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />


            </>
        )
    }

    return (
        <>

            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}